import { put, race, delay } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  set
} from '../redux/boardsBlockerCount'

export default function * fetchBoardsBlockerCount (action) {
  const { boardIds } = action.payload

  try {
    const getDataPromise = apiGetData('BlockersUseCount', {
      boardIds
    })

    const { getDataResult, timeout } = yield race({
      getDataResult: getDataPromise,
      timeout: delay(30000)
    })

    if (timeout) {
      getDataPromise.cancel()
    }

    if (getDataResult) {
      yield put(boardIds.map((boardId) => set({
        id: boardId,
        count: getDataResult.reduce((acc, BlockerCount) => {
          return acc + (BlockerCount.Boards.find(BoardCount => BoardCount.BoardId === boardId) || { Count: 0 }).Count
        }, 0),
      })))
    }
  } catch (e) {} // eslint-disable-line no-empty
}
